import axios from 'axios';

const currentVerInfo = () => axios.get(`/v1/account/version/`);

export { currentVerInfo };
